import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/[BlogsPage]/page.js")